import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTrelloComponent } from './simple-icons-trello.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTrelloComponent ],
    exports:      [ SimpleIconsTrelloComponent ],
    bootstrap:    []
})
export class SimpleIconsTrelloModule {}
